import {
 TEST,
 FETCH_USER_DATA
} from "../type";


export function test(isOpen:boolean) {
  return {
    type: TEST,
    payload: "",
  };
}
export function userData(details:any) {
  return {
    type: FETCH_USER_DATA,
    payload: details,
  };
}






